import { render, staticRenderFns } from "./SwitchHighRating.vue?vue&type=template&id=06636bec&"
import script from "./SwitchHighRating.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SwitchHighRating.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06636bec')) {
      api.createRecord('06636bec', component.options)
    } else {
      api.reload('06636bec', component.options)
    }
    module.hot.accept("./SwitchHighRating.vue?vue&type=template&id=06636bec&", function () {
      api.rerender('06636bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/DoctorFilters/components/SwitchHighRating/SwitchHighRating.vue"
export default component.exports